<template>
  <tr :class="(orderItem.quantity < orderItem.selected_qty?'tr_danger':'')">
    <td>{{ index + 1 }} <i v-if="(orderItem.quantity < orderItem.selected_qty?'tr_danger':'')" class="far fa-info-circle pulse"></i></td>
    <td>
      <input type="hidden" readonly :value="item.product_id" name="product_id[]">
      <input type="hidden" readonly :value="item.attr_hash" name="attr_hash[]">
      <input type="hidden" readonly :value="item.current_unit" name="unit_type[]">
      <input type="hidden" readonly :value="item.selected_qty" name="quantity[]">
      <div>{{ item.product_title }}</div>
      <div v-if="item.attr_str">({{ item.attr_str }})</div>
    </td>
    <td>
      <input class="form-control" @keyup="calculateItemBiggerUnit('small')" type="tel" name="real_quantity[]" v-model="orderItem.selected_qty" >
      <div class="text-danger">عدد</div>
    </td>
    <td>
      <input v-if="orderItem.bigger_unit" class="form-control" @keyup="calculateItemBiggerUnit('big')" type="tel" name="big_quantity[]" v-model="orderItem.big_qty">
      <div v-else>--</div>
      <div v-if="orderItem.bigger_unit" class="text-danger">{{orderItem.bigger_unit_title}}</div>
    </td>
    <td><Money :number="item.price"></Money></td>
    <td><Money :number="item.total"></Money></td>
    <td>
      <i @click="removeItem()" class="far fa-trash-alt delBtn"></i>
    </td>
  </tr>
</template>

<script>
import Money from "./Money";
export default {
  name: "orderItem",
  methods:{
    calculateItemBiggerUnit(unit)
    {
      const orderItem = this.orderItem;
      if (orderItem.bigger_unit)
      {
        const bigger_unit_quantity = orderItem.bigger_unit_quantity;
        let selected_qty = Number(orderItem.selected_qty);
        if (unit === 'small')
        {
          if (!isNaN(selected_qty))
          {
            orderItem.big_qty = Math.round((selected_qty / bigger_unit_quantity)*100)/100;
          }
        }
        else if (unit === 'big')
        {
          if (orderItem.big_qty && !isNaN(orderItem.big_qty))
          {
            orderItem.selected_qty = Math.round((orderItem.big_qty * bigger_unit_quantity));
          }
        }
      }
    },
    removeItem()
    {
      this.del_item = new Date().getTime();
    }
  },
  components:{
    Money
  },
  data:function ()
  {
    return {
      orderItem:'',
      del_item:''
    }
  },
  watch:{
    "orderItem" :{
      handler(orderItem)
      {
        this.$emit('itemChanged',orderItem)
      }
    },
    del_item:{
      handler: function ()
      {
        this.$emit('del_items')
      },
      deep: true
    }
    // item:{
    //   handler()
    //   {
    //     this.callEmit = false;
    //     this.orderItem = JSON.parse(JSON.stringify(this.item));
    //     console.log(this.cartItem)
    //   },deep : true
    // },
  },
  mounted()
  {
    this.orderItem = JSON.parse(JSON.stringify(this.item))
    this.calculateItemBiggerUnit('small');
  },

  props:['item','index']
}
</script>

<style scoped>
.delBtn
{
  padding: 5px;
  color: #eb445a;
  font-size: 24px;
}
.tr_danger >td
{
  background: #f8d7da;
  border-color: #f5c2c7;
}
.pulse{
  border-radius: 50%;
  /*width: 20px;*/
  /*height: 20px;*/
  color: red;
  text-align: center;
  animation: animate-pulse 3s linear infinite;
  font-size: 11px;
}
@keyframes animate-pulse{
  0%{
    box-shadow: 0 0 0 0 rgba(255,109,74,0.7),  0 0 0 0 rgba(255,109,74,0.7);
  }
  40%{
    box-shadow: 0 0 0 25px rgba(255,109,74,0.0),  0 0 0 0 rgba(255,109,74,0.7);
  }
  80%{
    box-shadow: 0 0 0 25px rgba(255,109,74,0.0),  0 0 0 15px rgba(255,109,74,0);
  }
  100%{
    box-shadow: 0 0 0 0 rgba(255,109,74,0.0),  0 0 0 15px rgba(255,109,74,0);
  }

}
</style>